<template>
    <div>
        <DashView>
            <div class="container py-4">

        <!-- Données patient -->
        <div class="section-title">Données journalières patient</div>
            <div class="row g-3 mb-4">
                <div class="col-md-3">
                <div class="card bg-white" v-if="stats.patients!=null">
                    <h3>{{ stats.patients }}</h3>
                    <h5>Nouveau Patients</h5>
                </div>
                </div>
                <div class="col-md-3">
                <div class="card bg-white" v-if="stats.declasser!=null">
                    <h3>{{ stats.declasser }}</h3>
                    <h5>Dossiers déclassés</h5>
                </div>
                </div>
                <div class="col-md-3">
                    <div class="card bg-white" v-if="stats.rendez_vous!=null">
                        <h3>{{ stats.rendez_vous }}</h3>
                        <h5>Rendez-Vous</h5>
                    </div>
                </div>
                <div class="col-md-3">
                <div class="card bg-white" v-if="stats.urgences!=null">
                    <h3>{{ stats.urgences }}</h3>
                    <h5>Urgences</h5>
                </div>
                </div>
            </div>

            <!-- Données hospitalisation -->
            <div class="section-title">Données journalières Hospitalisation</div>
            <div class="row g-3 mb-4">
                <div class="col-md-4">
                <div class="card bg-white">

                     <h3>
                        {{ stats.nb_chambres_total > 0 
                            ? `${stats.nb_chambres_occupees}/${stats.nb_chambres_total}` 
                            : '0/0' }}
                    </h3>
                    <h5>
                        {{ stats.nb_chambres_total > 0 
                            ? 'Chambres Occupées' 
                            : 'Aucune chambre disponible' }}
                    </h5>
                </div>
                </div>
                <div class="col-md-4">
                <div class="card bg-white" v-if="stats.hospitalisees!=null">
                    <h3>{{ stats.hospitalisees }}</h3>
                    <h5>Hospitalisées</h5>
                </div>
                </div>
                <div class="col-md-4">
                <div class="card bg-white" v-if="stats.exaats!=null">
                    <h3>{{ stats.exaats }}</h3>
                    <h5>Exéats</h5>
                </div>
                </div>
            </div>

            <!-- Données financières -->
    <div class="section-title">Données Finance</div>
    <div class="row g-3">
        <!-- <div class="col-md-4">
            <div class="card bg-white">
                <h4>{{ stats.montant_facture }} HTG</h4>
                <div class="fa-solid fa-arrow-up fa-3x my-2 text-info"></div>
                <p class="mb-1">{{stats.variation_pourcent}}%</p>
                <small>Montant facturé à la hausse par rapport à hier</small>
            </div>
        </div> -->
        <div class="col-md-4">
            <div class="card bg-white">
                <h4>{{ stats.montant_facture }} HTG</h4>

                <div v-if="stats.variation_pourcent > 0" class="fa-solid fa-arrow-up fa-3x my-2 text-success"></div>
                <div v-else-if="stats.variation_pourcent < 0" class="fa-solid fa-arrow-down fa-3x my-2 text-danger"></div>
                <div v-else class="fa-solid fa-minus fa-3x my-2 text-secondary"></div>
                <p class="mb-1">{{ stats.variation_pourcent }}%</p>
                <small>
                    <template v-if="stats.variation_pourcent > 0">
                        Montant facturé à la hausse par rapport à hier
                    </template>
                    <template v-else-if="stats.variation_pourcent < 0">
                        Montant facturé à la baisse par rapport à hier
                    </template>
                    <template v-else>
                        Aucun changement par rapport à hier
                    </template>
                </small>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card bg-white">
                <h4>{{ stats.montant_facture }} HTG</h4>

                <div v-if="stats.variation_pourcent > 0" class="fa-solid fa-arrow-up fa-3x my-2 text-success"></div>
                <div v-else-if="stats.variation_pourcent < 0" class="fa-solid fa-arrow-down fa-3x my-2 text-danger"></div>
                <div v-else class="fa-solid fa-minus fa-3x my-2 text-secondary"></div>
                <p class="mb-1">{{ stats.variation_pourcent }}%</p>
                <small>
                    <template v-if="stats.variation_pourcent > 0">
                        Montant facturé à la hausse par rapport à hier
                    </template>
                    <template v-else-if="stats.variation_pourcent < 0">
                        Montant facturé à la baisse par rapport à hier
                    </template>
                    <template v-else>
                        Aucun changement par rapport à hier
                    </template>
                </small>
            </div>
        </div>
        <div class="col-md-4 mb-5">
            <div class="card bg-white">
                <div class="row">
                    <div class="col-md-6">
                    <div class="text-start mt-3">
                    <div><span class="legend-box" style="background-color:#00aaff;"></span> Consultation</div>
                    <div><span class="legend-box" style="background-color:#ffaa00;"></span> Rendez-Vous</div>
                    <div><span class="legend-box" style="background-color:#ff0000;"></span> Laboratoire</div>
                    <div><span class="legend-box" style="background-color:#9900cc;"></span> Pharmacie</div>
                    <div><span class="legend-box" style="background-color:#cc0000;"></span> Hospitalisation</div>
                    </div>
                    </div>
                    <div class="col-md-6">
                        <div class="chart-circle mb-3"></div>
                    </div>
                    <br>                    
                </div>
                <small class="fw-bold">Montant facturé à la hausse par rapport à hier</small>
               
                
                
            </div>
        </div>
    </div>

</div>
        </DashView>
    </div>
</template>

<script>
    import axios from 'axios'
    import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
    import DashView from '@/components/DashView.vue'
    export default {
        name:"DashBoardView",
        components:{
            DashView
        },
        data(){
            return{
                stats : [],
                accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',

            }

        },
        created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        axios.get(`${base_url}/stats`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data);
                  if(response.data){
                      this.stats = response.data;
                  }
                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
        },
    }
</script>

<style scoped>
body {
      background-color: #e6f0fc;
    }
    .card {
      text-align: center;
      padding: 20px;
      border: none;
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0,0,0,0.05);
    }
    .card h5 {
      font-size: 1.2rem;
      margin-top: 10px;
    }
    .arrow-up {
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-bottom: 40px solid #00aaff;
      margin: auto;
    }
    .section-title {
      font-weight: bold;
      font-size: 1.1rem;
      margin-bottom: 10px;
    }
    .chart-circle {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background-color: #00aaff;
      margin: auto;
    }
    .legend-box {
      width: 12px;
      height: 12px;
      display: inline-block;
      margin-right: 5px;
    }
</style>